import PropTypes from 'prop-types';
import { FIRST_LAST, LAST_FIRST, EDGES_CENTER, CENTER_EDGES, RANDOM } from './TextAnimMode';
import { LINES, WORDS, CHARS } from './TextAnimSplit';
import TextAnimChildren from './TextAnimChildren';
import TextAnim from './TextAnim';
import css from './TextAnim.scss';

export const classes = {
	textAnimChildren: css.textAnimChildren,
	textAnimChildrenRow: '',
	textAnimChildrenChar: '',
	textAnim: css.textAnim,
	textAnimRow: css.textAnimRow,
	textAnimChar: css.textAnimChar,
	enter: css.enter,
	leave: css.leave,
};

export const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	children: PropTypes.node,
	dangerouslySetInnerHTML: PropTypes.exact({ __html: PropTypes.string.isRequired }),
	split: PropTypes.oneOf([LINES, WORDS, CHARS]),
	sort: PropTypes.oneOf([FIRST_LAST, LAST_FIRST, EDGES_CENTER, CENTER_EDGES, RANDOM]),
	debug: PropTypes.bool,
	type: PropTypes.string,
	useCssAnimation: PropTypes.bool,
	stagger: PropTypes.number,
	enter: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	leave: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
	onEnterChar: PropTypes.func,
	onLeaveChar: PropTypes.func,
	onEnter: PropTypes.func,
	onLeave: PropTypes.func,
};

export const defaultProps = {
	...TextAnimChildren.defaultProps,
	classes,
	children: null,
	dangerouslySetInnerHTML: null,
	split: LINES,
	sort: FIRST_LAST,
	debug: false,
	type: 'div',
	useCssAnimation: true,
	stagger: 0.015,
	enter: classes.enter,
	leave: classes.leave,
	onEnterChar: Function.prototype,
	onLeaveChar: Function.prototype,
	onEnter: Function.prototype,
	onLeave: Function.prototype,
};

TextAnim.propTypes = propTypes;
TextAnim.defaultProps = defaultProps;
TextAnim.displayName = 'TextAnim';
export { TextAnim, TextAnimChildren };
export default TextAnim;
